import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { clearObject } from 'src/app/reports/helpers/data.helper';
import { ToolbarBaseComponent } from 'rte-library';
import { ReportViewComponent } from '../../../report-view/report-view/report-view.component';
import { ReportSettings, OrientationEnum } from '../../../report-view/report-settings/models/reportsettings.model';
import { Report } from '../../models/report.model';
import { Subscription } from 'rxjs';
import { ReportRenderComponent } from '../../../report-view/report-render/report-render.component';
import { ReportRender } from 'src/app/models/reportRender';
import { Schema, SchemaForm } from 'src/app/reports/shared/rte-form/schema/schema.model';

@Component({
  selector: 'app-toolbar-menu-pre-view',
  templateUrl: './toolbar-menu-pre-view.component.html',
  styleUrls: ['./toolbar-menu-pre-view.component.scss']
})
export class ToolbarMenuPreViewComponent extends ToolbarBaseComponent implements OnInit, OnDestroy {

  @Input() reportView: ReportViewComponent;
  @Input() reportRender: ReportRenderComponent;
  @Input() showReportViewOrRender: ReportRender;
  @Input() settings: ReportSettings;
  @Input() report: Report;
  @Input() parameters: any;
  @Input() reportViewer: boolean;
  @Input() form: SchemaForm;

  @Output() reportViewerReturn: EventEmitter<boolean> = new EventEmitter<boolean>();

  subscriptions: Subscription = new Subscription();

  constructor() {
    super();
  }

  ngOnInit() { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  clearObject() {
    clearObject(this.reportView.parameter);
    this.reportView.settings.PageSize = 20;
    this.reportView.settings.PageSizeDetail = 20;
    this.reportView.settings.StripedLines = false;
    this.reportView.settings.ExpandDetail = false;
    this.reportView.settings.DisableStripedLinesOnDetail = false;
    this.reportView.settings.Orientation = OrientationEnum.Portrait;
  }

  back() {
    if (!this.showReportViewOrRender || !this.showReportViewOrRender.showReportRender) {
      this.reportViewerReturn.emit(false);
    }
    this.showReportViewOrRender.showReportView = true;
    this.showReportViewOrRender.showReportRender = false;

  }

  onViewReportClick() {
    this.reportView.onViewReportClick();
  }
}
